import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

@Pipe({
  name: 'currencyFormat',
  standalone: true
})
export class CurrencyFormatPipe implements PipeTransform {
  #currencyService = inject(CurrencyService);

  /** Format value with app currency, or with optional currency code (e.g. 'CAD', 'USD'). */
  transform(value: number | string | null | undefined, digitsInfo?: string, currencyCode?: string): string {
    return this.#currencyService.formatCurrency(value, digitsInfo, currencyCode);
  }
}
